<template>
  <div>
    <b-row class="d-flex flex-column mt-3">
      <!-- BANK TRANSFER BUTTON -->
      <b-col
        v-if="getTerritory() === 'UK' && bookingInfo.paybal_wbt === 'true'"
        class="col-sm-6 justify-content-center align-self-center"
      >
        <b-button
          class="pay-button my-3"
          block
          @click="loadBankTransfer"
        >
          Pay By Bank Transfer
        </b-button>
      </b-col>

      <b-col
          v-if="getTerritory() === 'IE'&& bookingInfo.paybal_menu === 'true'"
          class="col-sm-6 justify-content-center align-self-center"
      >
        <b-button
            class="pay-button my-3"
            block
            @click="openIEPaymentModal"
        >
          Pay By Bank Transfer
        </b-button>
      </b-col>

      <!-- PAY BY CARD BUTTON -->
      <b-col 
        v-if="showOnlinePayments" 
        class="col-sm-6 justify-content-center align-self-center"
      >
        <b-button
          v-if="accountInfo.paybal_menu === 'true'"
          class="pay-button my-3"
          block
          @click="loadCardPayment('card')"
        >
          Pay By Card
        </b-button>
      </b-col>

      <!-- APPLE/GOOGLE PAY BUTTON --> 
      <b-col 
        v-if="showOnlinePayments && !cardholderIntAddress" 
        class="col-sm-6 justify-content-center align-self-center"
      >
        <b-button
          v-if="(accountInfo.paybal_menu === 'true' && !cardholderIntAddress)"
          class="pay-button my-3"
          block
          @click="loadCardPayment('contactless')"
        >
          <i
            v-if="isCompatiable"
            class="icon-apple align-middle"
          />
          <i
            v-else
            class="icon-google align-middle"
          />
        </b-button>
      </b-col>
      <!-- REEDEM GIFT CARD OR VOUCHER -->
      <!-- ONLY PACKAGES CAN PAY THIS WAY-->
      <b-col 
        v-if="this.booking.booking_information.holiday_type.code === 'PA' || this.booking.booking_information.holiday_type.code === 'ZZ'"
        class="col-sm-6 justify-content-center align-self-center"
      >
        <b-button
          class="pay-button my-3"
          block
          @click="loadRedeemVoucher"
        >
          Redeem Gift Card or Voucher
        </b-button>
      </b-col>
    </b-row>
    
    <!-- BANK TRANSFER DROPDOWN -->
    <div class="item-top border-grey my-3">
      <b-collapse
        id="banktransfer"
        ref="banktransfer"
        accordion="my-accordion"
        role="tabpanel"
      >
        <div class="p-2 d-flex justify-content-end">
          <b-button 
            v-b-toggle:banktransfer 
            class="form-close-btn"
            type="button"
          >
            X
          </b-button>
        </div>

        <div
          v-if="getTerritory() === 'UK'"
          class="mx-2 mt-3"
        >
          <p class="text-center">
            <strong> Pay direct to our Trust Account</strong><br>
          </p>
          <h5>
            <p class="text-center">
              Your outstanding balance is:
              <strong>{{ bookingInfo.booking_currency }}{{ checkFinalPayment() }}</strong>
            </p>
          </h5>

          <div 
            class="mt-2 mb-3 text-center"
          >
            <strong>Secure &amp; Instant Online Bank Transfer</strong>
            <h5>
              <p class="text-center">
                Click on Pay by Bank Transfer and follow the simple
                instructions. We will receive a secure payment directly from
                your bank account instantly.
              </p>
            </h5>

            <div>
              <b-form-group
                label="Name"
                label-for="payment-name"
              >
                <b-form-select
                  id="payment-name"
                  v-model="selectedPassenger"
                  :options="passengerOptions"
                  :disabled="showPaymentOptions"
                  @change="findPersonalData"
                />
              </b-form-group>
                
              <b-form-group
                label="Email"
                label-for="payment-email"
              >
                <b-form-input
                  id="email-input"
                  v-model="paymentEmail"
                />
              </b-form-group>

              <b-form-group
                :label="fullPayment ? 'Amount to Pay' : 'Amount to Pay (editable)'"
                label-for="payment-amount"
              >
                <b-form-input
                  id="payment-input"
                  v-model="paymentCost"
                  type="number"
                  :readonly="fullPayment"
                />
              </b-form-group>
            </div>

            <div>
              <p><strong> Click the Bank Transfer box below</strong></p>
              <img 
                class="amex-img my-4" 
                src="https://icm.aexp-static.com/Internet/IMDC/paywithbank/images/pwb-desktop-dark.png" 
                alt="amex-logo" 
                @click="loadAmexButton()"
              >
            </div>
          </div>
        </div>
      </b-collapse>
    </div>

    <!-- CARD PAYMENT FORM DROPDOWN -->
    <div>
      <b-collapse
        id="paymentForm"
        ref="paymentForm"
        accordion="my-accordion"
        role="tabpanel"
      >
        <div class="p-2 d-flex justify-content-end">
          <b-button 
            class="form-close-btn" 
            type="button"
            @click="togglePaymentForm"
          >
            X
          </b-button>
        </div>

        <b-card
          class="my-4 text-center pay-header booking"
          style="height: 100px"
        >
          <h2 class="booking-p">
            <strong>Booking Reference: {{ bookingNo.toUpperCase() }}</strong> 
          </h2>
        </b-card>

        <div v-if="finalPayment === false && barclaysSuccess === false">
          <b-card
            bg-variant="light"
            class="mb-2 text-center"
            style="height: 8%"
          >
            <h4>
              Cardholder Details
            </h4>
            <h6 class="card-h6">
              Add details as they appear on the card
            </h6>
          </b-card>
          <b-row
            class="my-4"
            align-h="around"
          >
            <b-col :cols="mobile ? 12 : 6">
              <b-form-group
                label="Cardholder Name"
                label-for="cardholder-name"
                label-size="sm"
              >
                <b-form-select
                  v-model="selectedPassenger"
                  :options="passengerOptions"
                  :disabled="showPaymentOptions"
                  @change="findPersonalData"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <div v-if="selectedPassenger === 'guest'">
            <b-row
              class="mt-4"
              align-h="around"
            >
              <b-col :cols="mobile ? 12 : 5">
                <b-form-group
                  label="Cardholder's Title"
                  label-for="title"
                  label-size="sm"
                >
                  <b-form-select
                    v-model="cardholderTitle"
                    :disabled="showPaymentOptions"
                    :options="titles"
                  />
                  <div
                    v-if="!$v.cardholderTitle.required"
                    class="error"
                  >
                    <span class="error-field">Title is required</span>
                  </div>
                </b-form-group>
              </b-col>
              <b-col
                :cols="mobile ? 12 : 5"
                align-h="center"
              >
                <b-form-group
                  label="Cardholder's First Name"
                  label-for="cardholder-name"
                  label-size="sm"
                  :class="{ 'form-group--error': $v.cardholderName.$error }"
                >
                  <b-form-input
                    id="card-name-input"
                    v-model="cardholderName"
                    :disabled="showPaymentOptions"
                  />
                  <div
                    v-if="!$v.cardholderName.required"
                    class="error"
                  >
                    <span class="error-field">Name is required</span>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row align-h="around">
              <b-col :cols="mobile ? 12 : 5">
                <b-form-group
                  label="Cardholder's Surname"
                  label-for="cardholder-name"
                  label-size="sm"
                  :class="{ 'form-group--error': $v.cardholderSurname.$error }"
                >
                  <b-form-input
                    id="card-name-input"
                    v-model="cardholderSurname"
                    :disabled="showPaymentOptions"
                  />
                  <div
                    v-if="!$v.cardholderSurname.required"
                    class="error"
                  >
                    <span class="error-field">Surname is required</span>
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="5" />
            </b-row>
          </div>

          <div v-if="selectedPassenger">
            <b-card
              bg-variant="light"
              class="mb-4 text-center"
              :style="mobile === true ? 'height:100px' : 'height:70px'"
            >
              <h4 class="mb-4">
                Cardholder Contact Details
              </h4>
            </b-card>
            <b-row
              v-if="modalPayType === 'card'"
              class="mt-5 mb-3"
              align-h="around"
            >
              <b-col :cols="mobile ? 12 : 5">
                <b-form-group
                  label="International Address"
                  label-for="intAddress"
                  label-size="sm"
                >
                  <b-form-checkbox
                    id="intAddress"
                    v-model="cardholderIntAddress"
                    :disabled="showPaymentOptions"
                    name="intAddress"
                    :value="true"
                    :unchecked-value="false"
                    size="sm"
                    class="pull-left"
                  >
                    &nbsp; Tick here if your address is outside of
                    {{ bookingInfo.booking_site === "com" ? "UK" : "IE" }}
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col :cols="mobile ? 12 : 5">
                <b-form-group
                  v-if="cardholderIntAddress"
                  label="Country"
                  label-for="countryCode"
                  label-size="sm"
                >
                  <div class="select-holder">
                    <b-form-select
                      id="countryCode"
                      v-model="cardholderCountryCode"
                      :disabled="showPaymentOptions"
                      name="countryCode"
                      :options="countryCodes"
                    />
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row
              class="mt-5"
              align-h="around"
            >
              <b-col :cols="mobile ? 12 : 5">
                <b-form-group
                  label="First line of address"
                  label-for="title"
                  label-size="sm"
                  :class="{ 'form-group--error': $v.cardholderAddress1.$error }"
                >
                  <b-form-input
                    id="title-input"
                    v-model="cardholderAddress1"
                    :disabled="showPaymentOptions"
                  />
                  <div
                    v-if="!$v.cardholderAddress1.required"
                    class="error"
                  >
                    <span class="error-field">Address is required</span>
                  </div>
                </b-form-group>
              </b-col>
              <b-col
                :cols="mobile ? 12 : 5"
                align-h="center"
              >
                <b-form-group
                  label="Second line of address"
                  label-for="cardholder-name"
                  label-size="sm"
                  :class="{ 'form-group--error': $v.cardholderAddress2.$error }"
                >
                  <b-form-input
                    id="card-name-input"
                    v-model="cardholderAddress2"
                    :disabled="showPaymentOptions"
                  />
                  <div
                    v-if="!$v.cardholderAddress2.required"
                    class="error"
                  >
                    <span class="error-field">Address is required</span>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row align-h="around">
              <b-col :cols="mobile ? 12 : 5">
                <b-form-group
                  label="Third line of address"
                  label-for="cardholder-name"
                  label-size="sm"
                >
                  <b-form-input
                    id="card-name-input"
                    v-model="cardholderAddress3"
                  />
                </b-form-group>
              </b-col>
              <b-col
                :cols="mobile ? 12 : 5"
                align-h="center"
              >
                <b-form-group
                  :label="getTerritory() === 'UK' ? 'Postcode' : 'Eircode'"
                  label-for="cardholder-name"
                  label-size="sm"
                  :class="{ 'form-group--error': $v.cardholderPostcode.$error }"
                >
                  <b-form-input
                    id="card-name-input"
                    v-model="cardholderPostcode"
                    :disabled="showPaymentOptions"
                  />
                  <div
                    v-if="!$v.cardholderPostcode.required"
                    class="error"
                  >
                    <span class="btn-outline-danger">Postcode is required</span>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <div>
              <b-form-group
                label="Email address (where confirmation will be sent)"
                label-for="payment-email"
                label-size="sm"
              >
                <b-input-group prepend="@">
                  <b-form-input
                    id="email-input"
                    v-model="paymentEmail"
                    :disabled="showPaymentOptions"
                  />
                </b-input-group>
              </b-form-group>
            </div>
            <div>
              <b-form-group
                :label="fullPayment ? 'Amount to Pay' : 'Amount to Pay (editable)'"
                label-for="payment-email"
                label-size="sm"
              >
                <b-card
                  bg-variant="light"
                  class="mb-2 text-center"
                >
                  <b-row align-h="between">
                    <b-col
                      :cols="mobile ? 12 : 5"
                      class="mt-2"
                    >
                      <h5>
                        <p>Your outstanding balance is: {{ paymentCost }}</p>
                      </h5>
                    </b-col>
                    <b-col
                      :cols="mobile ? 12 : 5"
                      class="mt-"
                    >
                      <b-input-group
                        :prepend="getTerritory() === 'UK' ? '£' : '€'"
                      >
                        <b-form-input
                          id="payment-input"
                          v-model="paymentCost"
                          :disabled="showPaymentOptions"
                          type="number"
                          :readonly="fullPayment"
                        />
                      </b-input-group>
                    </b-col>
                  </b-row>
                </b-card>
              </b-form-group>
            </div>
            
            <b-card
              v-if="showPaymentOptions"
              bg-variant="light"
              class="mb-2 text-center w-100"
              :style="mobile === true ? 'height:100px' : 'height:70px'"
            >
              <div class="d-flex">
                <div class="w-50">
                  <h4>
                    <p class="mb-4">
                      Payment Options:
                    </p>
                  </h4>
                </div>
                <div class="w-50">
                  <b-button
                    v-if="((modalPayType === 'contactless') && showPaymentOptions)"
                    class="edit-btn float-right"
                    :style="mobile ? 'margin-bottom: 10px;' : 'min-height: 77%; margin-bottom: 10px;' "
                    variant="outline-dark"
                    @click="toggleEdit"
                  >
                    Edit
                  </b-button>
                </div>
              </div>
            </b-card>

            <div>
              <b-alert
                v-if="formInvalid"
                variant="danger"
                class="text-center"
                show
              >
                Please Complete All Fields On This Form In Order To Continue.
              </b-alert>
            </div>

            <b-row class="d-flex flex-column">
              <b-col class="col-sm-7 justify-content-center align-self-center">
                <b-button
                  v-if="modalPayType === 'card'"
                  class="mt-2 ml-0 pay-form-button"
                  block
                  @click="cardPaymentNext"
                >
                  Debit Card
                </b-button>
              </b-col>
              <b-col class="col-sm-7 justify-content-center align-self-center">
                <b-button
                  v-if="modalPayType === 'card'"
                  class="mt-3 ml-0 pay-form-button"
                  block
                  @click="cardPaymentNext"
                >
                  Credit Card
                </b-button>
              </b-col>
            </b-row>

            <div
              v-if="!cardholderIntAddress"
              class="text-center d-flex justify-content-center"
            >
              <div
                v-if="((modalPayType === 'contactless') && !showPaymentOptions)"
                class="mr-1"
              >
                <b-button
                  v-if="modalPayType === 'contactless'"
                  class="mt-2 ml-0 pay-form-button"
                  block
                  variant="dark"
                  @click="checkValidDetails"
                >
                  Next<b-icon
                    class="ml-2"
                    icon="credit-card"
                    aria-hidden="true"
                  />
                </b-button>
              </div>
              <div
                v-if="(modalPayType === 'contactless' && formIsValid)"
                class="mr-1"
              />
            </div>
            
            <div
              v-if="!cardholderIntAddress"
              class="row text-center d-flex justify-content-center w-100 ml-0 mr-0"
            >

            <b-col
              v-if="(modalPayType === 'contactless' && formIsValid)"
              :cols="mobile ? '12': '6'"
            >
                <ApplePay
                  class="mt-2"
                  :form-data="formData"
                  :form-invalid="formIsValid"
                  :is-compatiable="isCompatiable"
                  :payment-cost="paymentAmount.toString()"
                  @on-submit="applePaySubmit($event)"
                  @set-form-invalid="setFormInvalid"
                />
          </b-col>
          <b-col :cols="mobile ? '12': '6'"
            :class="mobile ? 'mt-3' : 'mt-2'"
            v-if="((modalPayType === 'contactless') && formIsValid)"
          >
          <GooglePay
                  class="mt-2"
                  :form-data="formData"
                  :form-invalid="formIsValid"
                  :payment-cost="paymentAmount.toString()"
                  @on-submit="googlePaySubmit($event)"
                  @set-form-invalid="setFormInvalid"
                />
        </b-col>
            </div>
          </div>
        </div>

        <div v-if="barclaysError === false && finalPayment === true">
          <h6>
            <p class="text-center">
              Payment amount:
            </p>
          </h6>
          <h4>
            <p class="text-center">
              {{ bookingInfo.booking_currency }}{{ paymentCost }}
            </p>
          </h4>
          <p class="text-center">
            As soon as your payment has been approved we will email you with confirmation
          </p>
          <div
            v-if="barclaysLoadingError"
            class="text-center"
          >
            <b-alert
              show
              variant="danger"
            >
              We could not process your payment. Please contact your
              consultant.<br>Error: {{ barclaysLoadingErrorText }}
            </b-alert>
          </div>
          <div class="loading-state" v-if="paymentLoading">
            <div class="spinner"></div>
          </div>
          <iframe
            v-if="!paymentLoading"
            id="payment-frame"
            :src="barclaysUrl"
          />
        </div>

        <div
          v-if="barclaysError"
          class="text-center"
        >
          <b-card
            bg-variant="danger"
            border-variant="orangered"
            text-variant="white"
            class="my-4 text-center"
            :style="getCardPaymentErrorPanelHeight()"
          >
            <h6 v-if="booking.account_information.fil === 'M'">
              We were unable to process your payment and your card has not been charged.
            </h6>
            <h5>
              This most likely relates to limits imposed by your card issuer for online payments - please contact them for more details.
              <br>
              <span class="lg-hide">
                Alternatively, you can call us on <a href="`tel: ${ branch_phone }`">{{ branch_phone }}</a> and pay over the phone. 
              </span> 
              <span class="hidden-mobile">
                Alternatively, you can call us on {{ branch_phone }} and pay over the phone. 
              </span> 
            </h5>
            <br>
          </b-card>
        </div>

        <div
          v-if="barclaysSuccess"
          class="text-center"
        >
          <b-card
            bg-variant="success"
            border-variant="orangered"
            text-variant="white"
            class="my-4 text-center"
          >
            <h6 v-if="booking.account_information.fil === 'M'">
              Your Payment has been processed.
            </h6>
            <h5>
              Thank You. Your payment has been received and we have sent you a
              confirmation email.
              <br>
              Please contact your local
              <a
                style="color: black"
                href="`/travel-centre/${booking.booking_information.branch_number}`"
              ><strong>Travel Centre</strong></a>
              if you have any queries. <br><br>
            </h5>
            <div>
              <p class="reload-text">
                This page will refresh automatically, please wait...
              </p>
              <i class="material-icons mr-3 reload-icon"></i>
            </div>
            <br>
          </b-card>
        </div>
      </b-collapse>
    </div>
    <!-- VOUCHERS AND GIFT CARDS -->
    <div>
      <b-collapse
        id="redeemvoucher"
        ref="redeemvoucher"
        accordion="my-accordion"
        role="tabpanel"
      >
        <div class="p-2 d-flex justify-content-end">
          <b-button 
            v-b-toggle:redeemvoucher 
            class="form-close-btn"
            type="button"
          >
            X
          </b-button>
        </div>

        <div
          v-if="booking && booking.user_information"
          class="mx-2 mt-3"
        >
          <b-card
            class="my-4 text-center pay-header booking"
            style="height: 100px"
          >
            <h2 class="booking-p">
              <strong>Booking Number: {{ bookingNo.toUpperCase() }}</strong> 
            </h2>
          </b-card>
          <RedeemVoucher
            :booking="booking"
            :load-redeem-voucher="loadRedeemVoucher"
            :travelling-names="travellingNames"
            :agreedToIssueFlights="agreedToIssueFlights"
            :fullBalanceAmount="payDisplay"
          />
        </div>
      </b-collapse>
    </div>
    <IEPaymentTransferInfo ref="IEPaymentTransferInfo" />
  </div>

</template>

<script>
import { mapActions, mapGetters } from "vuex"
import { countryCodes } from "@/assets/countryCodes";
import { amexButtonPayment, logToPapertrail } from "../services";
import { loginBookingNumber } from "../../../../../auth/services";
import { required } from 'vuelidate/lib/validators'
import platform from "platform";
import  GooglePay  from "@/partials/google-pay"
import ApplePay from "@/partials/apple-pay"
import { generateTCEmailAddress } from "../account.module";
import RedeemVoucher from "../redeem-voucher/index.vue";
import IEPaymentTransferInfo from "../ie-payment-transfer-info";
import { getTravellingPassengers } from '../../../../../../lib/utilities';
const { VUE_APP_APPLE_PAY_MERCH_ID } = process.env

export default {
  components: {
    GooglePay,
    ApplePay,
    RedeemVoucher,
    IEPaymentTransferInfo
  },
  props: {
    agreedToIssueFlights: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      barclaysData: {},
      showPaymentOptions:false,
      formIsValid: false,
      formInvalid: false,
      modalPayType: 'card',
      canMakeApplePayments: false,
      paymentLoading: false,
      paymentEmail: null,
      paymentCost: 0,
      titles: ["Select", "MR", "MRS", "MISS", "MS"],
      cardholderTitle: "",
      cardholderName: "",
      cardholderSurname: "",
      cardholderIntAddress: false,
      cardholderCountryCode: null,
      cardholderAddress1: "",
      cardholderAddress2: "",
      cardholderAddress3: "",
      cardholderPostcode: "",
      finalPayment: false,
      socket: null,
      barclaysUrl: "",
      barclaysError: false,
      barclaysSuccess: false,
      mobile: window.innerWidth <= 700,
      barclaysLoadingError: false,
      barclaysLoadingErrorText: "",
      finalPaymentCost: "",
      countryCodes: countryCodes,
      selectedPassenger: null
    };
  },
  validations () {
    return {
      cardholderSurname: { required },
      cardholderName: {required},
      cardholderAddress1: {required},
      cardholderAddress2: { required },
      cardholderPostcode: { required },
      cardholderTitle: {required}
    }
  },
  watch: {
    booking: function(_val) {
      if (this.getTerritory() === "UK") {
        this.finalPaymentCost = `£${this.paymentCost}`;
      } else {
        this.finalPaymentCost = `€${this.paymentCost}`;
      }
    }
  },
  created() {
    this.checkApplePay();
    this.formData.issueFlights = Boolean(this.agreedToIssueFlights)
    addEventListener("resize", () => {
      this.mobile = innerWidth <= 700;
    });
  },
  computed: {
    ...mapGetters({
      accountInfo: "booking/getAccount",
      booking: "booking/getBooking",
      bookingNo: "booking/getBookingNumber",
      getBookingSurname: "booking/getBookingSurname",
      bookingInfo: "booking/getBookingInfo",
      userData: "auth/getUserData",
      hasAddedInsurance: "navigation/getAddedInsurance",
      paxNames: 'booking/getBookingPassengers'
    }),
    branch_phone() {
      if (this.booking && this.booking.user_information) {
        return this.booking.user_information.bkgcontacts[0].line0.telno;
      }
      return null;
    },
    showOnlinePayments() {
      if (
        (this.accountInfo.paybal_wbt === "true" &&
          this.accountInfo.paybal_menu === "false") ||
        (this.accountInfo.paybal_wbt === "false" &&
          this.accountInfo.paybal_menu === "false") ||
        (this.accountInfo.paybal_wbt === "true" &&
          this.accountInfo.paybal_menu === "false")
      ) {
        return false;
      }
      return true;
    },
    isCompatiable() {
      return this.canMakeApplePayments;
    },
    fullPayment() {
      if (
        (this.bookingInfo.holiday_type &&
          this.bookingInfo.holiday_type.code === 'FO') ||
        this.agreedToIssueFlights
      ) {
        return true
      }
      return false
    },
    formData() {
      return this.buildBarclaysData()
    },
    payDisplay() {
      // override the standard deposit which is the 'balanceCost' if the booking is a Prov, and the client has agreed to issue flights early
      return this.agreedToIssueFlights && this.accountInfo.fil === 'P' ? this.booking.account_information.totalCost : this.booking.account_information.balanceCost;
    },
    paymentAmount() {
      return this.paymentCost
    },
    isStaffBooking(){
      return this.bookingInfo.staffbkg === "Y";
    },
    passengerOptions(){
      const arr = [{value: null, text: "Please select who is paying..."}]
      const travellingPax = getTravellingPassengers(
        this.booking.user_information.names, this.paxNames
      )
      travellingPax.forEach((pax) => {
        arr.push({
          text: pax.name, 
          value: pax,
        })
      });
      arr.push({value: "guest", text: "Somebody not travelling"})
      return arr;
    },
    travellingNames(){
      return getTravellingPassengers(
        this.booking.user_information.names, this.paxNames
      )
    },
  },
  methods: {
    ...mapActions({
      loginOnStart: "auth/loginBookingNumberOnStartAction",
      loadBooking: "booking/loadBookingAction"
    }),
    openIEPaymentModal() {
      this.$refs.IEPaymentTransferInfo.showModal();
    },
    getTerritory() {
      return this.bookingInfo.booking_site === "com" ? "UK" : "IE";
    },
    setFormInvalid() {
      this.formInvalid = true
    },
    loadBankTransfer() {
      this.paymentCost = this.checkFinalPayment();
      this.$refs.banktransfer.toggle();
    },
    loadRedeemVoucher() {
      this.$refs.redeemvoucher.toggle();
    },
    loadCardPayment(payType) {
      this.paymentCost = this.checkFinalPayment();
      let socket_url = location.hostname === "localhost" ? "http://localhost:8318" : ''
      let socket_path = "/so-api/barclay/socket";
      let sent_error = false;

      this.socket = window.io(socket_url, {
        path: socket_path,
        transports: ["polling"]
      });
      this.socket.on("connect_error", async () => {
        if (sent_error === false) {
          sent_error = true;
          await logToPapertrail(
            "Payment Socket Error - connection failure: " +
              this.bookingNo +
              " " +
              platform.description
          );
        }
      });
      this.modalPayType = payType
      this.$refs.paymentForm.toggle();
    },
    checkFinalPayment() {
      let balanceWithoutInsurance = this.accountInfo.balanceCostNoSymbol.trim()
      if (this.agreedToIssueFlights && this.accountInfo.fil === 'P') {
        // full payment if prov, remaining balance if main
        balanceWithoutInsurance = this.accountInfo.totalCostNoSymbol.trim()
      }

      if (this.hasAddedInsurance) {
        return (
          Math.round(
            (Number(balanceWithoutInsurance) +
              Number(this.accountInfo.insquoteamount)) *
              100
          ) / 100
        );
      } else {
        return balanceWithoutInsurance
      }
    },
    checkValidDetails() {
      this.formInvalid = false
      this.showPaymentOptions = false
      if (
      Number(this.paymentCost) <= 0 |
      this.cardholderTitle === '' |
      this.cardholderName === '' |
      this.cardholderSurname === '' |
      this.cardholderAddress1 === '' |
      this.cardholderAddress2 === '' |
      this.cardholderPostcode === '' |
      this.paymentEmail === '') {
        this.formInvalid = true
        this.formIsValid = false
        return false
      } else {
        this.showPaymentOptions = true
        this.formIsValid = true
        return true
      }
    },
    buildBarclaysData() {
      let barclaysData = {};
      barclaysData.name =
        this.cardholderTitle +
        " " +
        this.cardholderName +
        " " +
        this.cardholderSurname;
      barclaysData.title = this.cardholderTitle;
      barclaysData.firstname = this.cardholderName;
      barclaysData.surname = this.cardholderSurname;
      barclaysData.billingAddressLine1 = this.cardholderAddress1;
      barclaysData.billingAddressLine2 = this.cardholderAddress2 || '-'; // for vt-secure, a non empty string value is required
      barclaysData.billingAddressLine3 = this.cardholderAddress3 || "-";
      barclaysData.billingAddressPostcode = this.cardholderPostcode;
      if (
        this.booking.user_information.bookingNumber.charAt(0).toUpperCase() ===
        "R"
      ) {
        const postcodeSegments = barclaysData.billingAddressPostcode.split(" ");
        if (
          Array.isArray(postcodeSegments) &&
          postcodeSegments.length === 2 &&
          postcodeSegments[0] === "IRELAND"
        ) {
          barclaysData.billingAddressLine3 = postcodeSegments[0];
          barclaysData.billingAddressPostcode = postcodeSegments[1];
        }
      }
      if (this.cardholderIntAddress && this.cardholderCountryCode !== null) {
        barclaysData.countryCode = this.cardholderCountryCode;
      }
      barclaysData.logname = this.bookingInfo.logname;
      barclaysData.branchno = this.bookingInfo.branch_number;
      barclaysData.bookno = this.booking.user_information.bookingNumber;
      barclaysData.fil = this.accountInfo.fil;
      barclaysData.country = this.getTerritory();
      barclaysData.site = "TF";
      barclaysData.purchaseDescription = this.booking.user_information.bookingNumber;
      barclaysData.currencyCode = this.bookingInfo.booking_currency === "£" ? `GBP` : `EUR`;
      barclaysData.purchaseAmount = this.paymentCost;
      barclaysData.holidayType = (this.bookingInfo.holiday_type && this.bookingInfo.holiday_type.code) ? this.bookingInfo.holiday_type.code : "";
      barclaysData.vt_data = {
        send_to: this.paymentEmail, // who to send it to.
        reply_to:  generateTCEmailAddress(
        this.booking.booking_information.branch_number),
        lead_surname: this.booking.booking_information.lead_surname,
        consultant: this.booking.consultant_information.name,
        balancenoCost: this.booking.account_information.balanceCostNoSymbol,
        fil: this.booking.booking_information.fil,
        branchTelephone: this.booking.booking_information.branch_number,
        originator_system: "finalpayment",
        issueFlights: this.agreedToIssueFlights ? true : false,
        incProvIns: this.hasAddedInsurance ? "Y" : "N"
      }
      this.barclaysData = barclaysData
      return barclaysData
    },
    googlePaySubmit(googleData) {
      this.sfError = false;
      this.formInvalid = false;
        if (
          googleData &&
          googleData.detail.paymentMethodData.tokenizationData.token
        ) {
          this.formData.payType = "GooglePay"
          this.formData.sessionToken =
            googleData.detail.paymentMethodData.tokenizationData.token;
        }
        if (
          googleData &&
          !googleData.detail.paymentMethodData.tokenizationData.token
        ) {
          this.paymentError = true
        }
        this.isLoading = true
        this.cardPaymentNext()
    },
    checkApplePay() {
        if (window.ApplePaySession) {
          const merchantIdentifier = VUE_APP_APPLE_PAY_MERCH_ID;
          const validCardCheck = window.ApplePaySession.canMakePaymentsWithActiveCard(
            merchantIdentifier
          );
          validCardCheck.then(canMakePayments => {
            this.canMakeApplePayments = canMakePayments;
            return canMakePayments;
          });
        } else {
          this.canMakeApplePayments = false;
          return false;
        }
    },
    async applePaySubmit(appleData) {
      this.finalPayment = true;
        if (appleData) {
          this.formData.payType = "ApplePay";
          this.token = JSON.stringify(appleData)
          this.formData.sessionToken = JSON.stringify(appleData)
        }
        this.cardPaymentNext()
    },
    cardPaymentNext() {
      if(this.checkValidDetails()) {
        this.finalPayment = true;
        const tmpFormData = JSON.parse(JSON.stringify(this.formData));
        tmpFormData.id = this.selectedPassenger.id;
        tmpFormData.vt_data.issueFlights = this.agreedToIssueFlights ? true : false;
        this.socket.emit("begin", tmpFormData);
        let self = this;
        self.paymentLoading = true;
        self.barclaysLoadingError = false;
        //Initial call for card payment
        this.socket.on("beginResponse", function(beginResponse) {
          if (!beginResponse) {
          }
          if (beginResponse.paymentRedirectUrl) {
            self.paymentLoading = false;
            self.barclaysUrl = beginResponse.paymentRedirectUrl;
          } else {
            self.paymentLoading = false
            self.barclaysLoadingErrorText = beginResponse.error[0].message;
            self.barclaysLoadingError = true;
          }
        });
        //Completion of card payment
        this.socket.on("finished", function(finishedResponse) {
          self.paymentLoading = true;
          if (!finishedResponse.result || finishedResponse.status >= 400 || finishedResponse.error || (finishedResponse.result && !finishedResponse.result.status) || (finishedResponse.result && finishedResponse.result.status !== 'success')) {
            let message = this.bookingNo;
            if (finishedResponse.error) {
              if (finishedResponse.error.name) {
                message += " " + finishedResponse.error.name;
              }
              if (finishedResponse.error.content) {
                let content = JSON.parse(finishedResponse.error.content);
                message += " " + content.cancelReasonText;
                message += " " + JSON.stringify(content.billingAddress);
              }
            }
            self.paymentLoading = false;
            self.barclaysError = true;
          } else {
            self.barclaysSuccess = true;
            self.barclaysError = false;
            self.finalPayment = false;
            self.paymentLoading = false;
            setTimeout(() => {
              if (self.socket) {
                self.socket.disconnect();
              }
              self.finalPayment = false;
              self.barclaysError = false;
              self.barclaysSuccess = false;
              self.handlePaymentExit();
            }, 6000);
          }
        });
      } else {
        this.formInvalid = true
      }
    },
    async handlePaymentExit() {
      // update all store booking vals to get new balance
      const res = await loginBookingNumber(this.getBookingSurname, this.bookingNo, undefined)
      if(res.booking) {
        this.loadBooking(res.booking)
      }
      this.$emit("exitModal");
    },
    //Launch amex bank payment popup window for UK only
    async loadAmexButton() {
      await amexButtonPayment(
        this.booking, 
        this.paymentCost, 
        this.selectedPassenger, 
        this.paymentEmail,
        { 
          incProvIns: this.hasAddedInsurance ? "Y" : "N",
          issueFlights: this.agreedToIssueFlights ? true : false 
        }
      );
    },
    togglePaymentForm() {
      if (this.socket) {
        this.socket.disconnect();
      }
      this.finalPayment = false;
      this.barclaysError = false;
      this.barclaysSuccess = false;
      this.showPaymentOptions = false;
      this.formIsValid = false;
      this.$refs.paymentForm.toggle();

    },
    toggleEdit() {
      this.showPaymentOptions = !this.showPaymentOptions
      this.formIsValid = false
    },
    getCardPaymentErrorPanelHeight() {
      return this.mobile === true ? "height:170px" : "height:130px";
    },
    findPersonalData() {
      if (this.selectedPassenger && this.selectedPassenger !== "guest"){
        const [passenger] = this.paxNames.filter((pax) => pax.id === this.selectedPassenger.id);
        this.cardholderTitle = passenger.title;
        this.cardholderName = passenger.firstname;
        this.cardholderSurname = passenger.surname;
        this.cardholderAddress1 = passenger.address1;
        this.cardholderAddress2 = passenger.address2;
        this.cardholderAddress3 = passenger.address3;
        this.cardholderPostcode = passenger.postcode;
        this.paymentEmail = passenger.email;
      } else {
        this.cardholderTitle = "";
        this.cardholderName = "";
        this.cardholderSurname = "";
        this.cardholderAddress1 = "";
        this.cardholderAddress2 = "";
        this.cardholderAddress3 = "";
        this.cardholderPostcode = "";
        this.paymentEmail = "";
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import './styles.scss';
</style>



